<template>
	<form class="ranking" @submit.prevent="submitData">
		<table class="simple-table">
			<tr>
				<th>타이틀</th>
				<td><input type="text" v-model="rankingTitle" /></td>
			</tr>
			<tr>
				<th>하위카테고리</th>
				<td>
					<div class="ranking__selector__box">
						<template>
							<CategorySelector
								:big-size="true"
								:category-limit="50"
								ref="categorySelector"
								@change="setCategoryValue($event)"
							/>
						</template>
					</div>
				</td>
			</tr>
			<tr>
				<th>날짜</th>
				<td>
					<DateRange
						type="datetime-local"
						v-model="rankingDateRange"
					/>
				</td>
			</tr>
		</table>
		<div class="btn-wrap-main">
			<button
				type="submit"
				class="btn-main blue"
				v-text="getButtonName"
			/>
			<button
				type="button"
				class="btn-main blue bordered"
				v-text="'취소'"
				@click="cancel"
			/>
		</div>
	</form>
</template>
<script>
	import CategorySelector from '@/components/event/CategorySelector';
	import DateRange from '@/components/DateRange';
	import moment from 'moment';
	import { mapState } from 'vuex';

	export default {
		data() {
			return {
				rankingDateRange: { from: '', to: '' },
				rankingTitle: '',
				getCategoryList: [],
				setCatgeoryList: [],
			};
		},
		props: {
			mode: {
				type: String,
				default: 'register',
			},
		},
		components: {
			CategorySelector,
			DateRange,
		},
		computed: {
			...mapState({
				secondCategories: state => state.filter.secondCategories,
				thirdCategories: state => state.filter.thirdCategories,
			}),
			getButtonName() {
				return this.mode === 'modify' ? '수정' : '등록';
			},
		},
		watch: {
			getCategoryList() {
				this.setCatgeoryList = this.getCategoryList.map(item => {
					return {
						level: item.idThirdCategory ? 3 : 2,
						categoryId: item.idThirdCategory
							? item.idThirdCategory
							: item.idSecondCategory,
					};
				});
			},
		},
		mounted() {
			this.mode === 'modify' && this.detailData();
		},
		methods: {
			setCategoryValue(event) {
				this.setCatgeoryList = event.map(item => {
					return {
						level: item.idThirdCategory ? 3 : 2,
						categoryId: item.idThirdCategory
							? item.idThirdCategory
							: item.idSecondCategory,
					};
				});
			},
			async detailData() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/v3/api/category/rankingCuration/${this.$route.params.idRanking}`
					);
					this.rankingTitle = data.title;
					this.rankingDateRange.from = moment
						.unix(data.startOn)
						.format('YYYY-MM-DD HH:mm:ss');
					this.rankingDateRange.to = moment
						.unix(data.endOn)
						.format('YYYY-MM-DD HH:mm:ss');
					this.getCategoryList = data.categories;
					this.$refs.categorySelector.setList(this.getCategoryList);
				} catch (err) {
					console.error(err);
				}
			},
			async submitModify(params) {
				try {
					await this.$axiosAdmin2.put(
						`/v3/api/category/rankingCuration/${this.$route.params.idRanking}`,
						params
					);
					alert('수정되었습니다.');
					this.$router.push(`/product/manage-ranking-module`);
				} catch (err) {
					console.error(err);
					alert(
						'등록 실패하였습니다. 지속적인 오류 발생시 개발팀에 문의바랍니다.'
					);
				}
			},
			async submitRegister(params) {
				try {
					await this.$axiosAdmin2.post(
						'/v3/api/category/rankingCuration',
						params
					);
					alert('등록되었습니다.');
					this.$router.push(`/product/manage-ranking-module`);
				} catch (err) {
					console.error(err);
					alert(
						'등록 실패하였습니다. 지속적인 오류 발생시 개발팀에 문의바랍니다.'
					);
				}
			},
			validations() {
				const hasValue = this.setCatgeoryList.some(
					item => item.categoryId === null
				);
				if (!this.rankingTitle) {
					alert('제목을 입력해 주세요');
					return false;
				}
				if (this.setCatgeoryList && hasValue) {
					alert('카테고리를 입력해주세요');
					return false;
				}
				if (!this.rankingDateRange.from) {
					alert('시작일을 입력해주세요');
					return false;
				}
				if (!this.rankingDateRange.to) {
					alert('종료일을 입력해주세요');
					return false;
				}
				if (
					moment(this.rankingDateRange.to).valueOf() <
					moment(this.rankingDateRange.from).valueOf()
				) {
					alert('종료일이 시작일보다 이전날짜입니다');
					return false;
				}
				return true;
			},
			cancel() {
				this.$router.push('/product/manage-ranking-module');
			},
			submitData() {
				if (!this.validations()) {
					return false;
				}
				const params = {
					title: this.rankingTitle,
					startOn: moment(this.rankingDateRange.from).valueOf(),
					endOn: moment(this.rankingDateRange.to).valueOf(),
					categoryReqDTOList: this.setCatgeoryList,
				};

				if (this.mode === 'modify') {
					this.submitModify(params);
				} else {
					this.submitRegister(params);
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.ranking {
		.simple-table {
			margin-top: 30px;
		}
	}
	.ranking__selector__box {
		display: flex;
		align-items: center;
		border-radius: 6px;
	}

	.ranking__button-wrapper {
		text-align: center;
		padding-left: 10px;
	}

	.ranking__add {
		background: $btn-blue;
		width: 1.6em;
		height: 1.6em;
		border-radius: 50%;
		color: #fff;
	}
</style>
